!(function () {
  const t = {
    init(t) {
      const { sliderSelector: e } = t;
      (this.container = document.querySelector(".cart-mixmatch")),
        this.container &&
          ((this.model = { sliderSelector: e }),
          this.initialSetup(),
          (this.sliderSelector = e),
          (this.sliderDiv = this.container.querySelector(e)));
    },
    initialSetup() {
      const { sliderSelector: t } = this.getModel();
      this.slider = new Splide(".cart-mixmatch-container", {
        fixedWidth: "65%",
        perMove: 1,
        pagination: !1,
        gap: 10,
        classes: {
          arrows: "splide__arrows  custom-splide-arrows",
          arrow: "splide__arrow custom-splide-arrow",
          prev: "splide__arrow--prev custom-splide-arrow--prev",
          next: "splide__arrow--next custom-splide-arrow--next",
        },
      }).mount();
    },
    getModel() {
      return this.model;
    },
  };
  document.addEventListener("DOMContentLoaded", () => {
    t.init({ sliderSelector: ".cart-upsells" });
  });
  const e = {
    show(t, e) {
      t.classList.add(e ?? "d-block");
    },
    hide(t, e) {
      t.classList.remove(e ?? "d-block");
    },
    async addToCart(t) {
      try {
        const e = await fetch("/cart/add.js", {
            ...window.theme.fetchConfig(),
            body: JSON.stringify({
              id: t,
              quantity: 1,
              sections: ["cart-drawer"],
              sections_url: window.location.pathname,
            }),
          }),
          i = await e.text(),
          s = JSON.parse(i);
        s?.sections && window.theme.cart.render(s.sections["cart-drawer"]);
      } catch (t) {
        console.error(t), alert(t.description);
      }
    },
  };
  class i extends HTMLElement {
    constructor() {
      super(),
        (this.model = { color: null }),
        (this.productView = this.querySelector(".cart-upsell__main")),
        (this.optionsView = this.querySelector(".cart-upsell__options-box")),
        (this.colorsView = this.optionsView.querySelector(
          ".cart-upsell__swatches-box--colors"
        )),
        (this.secondaryOptionsView = this.optionsView.querySelector(
          ".cart-upsell__swatches-box:not(.cart-upsell__swatches-box--colors)"
        )),
        (this.select = this.querySelector("select")),
        (this.variantOptions = [...this.select.querySelectorAll("option")]),
        (this.pickColorBtn = this.querySelector(".pick-color-btn")),
        (this.addToCartBtn = this.querySelector(".add-to-cart-btn")),
        (this.arrowBtn = this.querySelector(".arrow-btn")),
        (this.colorSwatches = this.colorsView
          ? [...this.colorsView.querySelectorAll("input")]
          : []),
        (this.secondarySwatches = this.secondaryOptionsView
          ? [...this.secondaryOptionsView.querySelectorAll("input")]
          : []),
        (this.backBtn = this.querySelector(".back-btn")),
        this.setupEventListeners(),
        this.hideUnavailableOptions();
    }
    setupEventListeners() {
      this.optionsView &&
        (this.optionsView.oninput = this.handleOptionsViewInput.bind(this)),
        this.pickColorBtn &&
          (this.pickColorBtn.onclick = this.handlePickColorBtnClick.bind(this)),
        (this.addToCartBtn.onclick = this.handleAddToCartBtnClick.bind(this)),
        this.backBtn &&
          (this.backBtn.onclick = this.handleBackBtnClick.bind(this)),
        this.arrowBtn &&
          (this.arrowBtn.onclick = this.handleArrowBtnClick.bind(this));
    }
    hideUnavailableOptions() {
      const { show: t, hide: i } = e,
        s = [];
      this.colorSwatches.forEach((e) => {
        const n = this.variantOptions.reduce(
          (t, i) =>
            i.textContent.includes(e.value) && parseInt(i.dataset.inventory)
              ? [...t, i.value]
              : t,
          []
        );
        n?.length
          ? (t(e.nextElementSibling, "d-inline"), s.push(e))
          : i(e.nextElementSibling, "d-inline");
      });
      const n = [];
      this.secondarySwatches.forEach((e) => {
        const s = this.variantOptions.reduce(
          (t, i) =>
            i.textContent.includes(e.value) && parseInt(i.dataset.inventory)
              ? [...t, i.value]
              : t,
          []
        );
        s?.length
          ? (t(e.nextElementSibling, "d-inline"), n.push(e))
          : i(e.nextElementSibling, "d-inline");
      });
    }
    hideUnavailableSecondaryOptions() {
      const { show: t, hide: i } = e,
        s = [];
      this.secondarySwatches.forEach((e) => {
        const n = this.variantOptions.reduce(
          (t, i) =>
            i.textContent.includes(e.value) &&
            i.textContent.includes(this.model.color) &&
            parseInt(i.dataset.inventory)
              ? [...t, i.value]
              : t,
          []
        );
        n?.length
          ? (t(e.nextElementSibling, "d-inline"), s.push(e))
          : i(e.nextElementSibling, "d-inline");
      });
    }
    updateModel(t, e) {
      this.model[t] = e;
    }
    getModel() {
      return this.model;
    }
    handleOptionsViewInput(t) {
      const { target: e } = t,
        i = e?.dataset?.action;
      if (i)
        switch (i) {
          case "select-color":
            this.handleColorSelection(e);
            break;
          case "select-option":
            this.handleSecondaryOptionSelection(e);
        }
    }
    handleColorSelection(t) {
      const { show: i, hide: s } = e;
      if (
        ((this.model.color = t.value),
        this.hideUnavailableSecondaryOptions(),
        (this.secondaryOptionsView
          ? this.secondaryOptionsView.querySelectorAll("label.d-inline")
          : []
        ).length > 1)
      )
        s(this.colorsView), i(this.secondaryOptionsView);
      else if (this.secondaryOptionsView) {
        const t =
          this.secondaryOptionsView.querySelector(
            "label.d-inline"
          ).previousElementSibling;
        this.model[t.dataset.name] = t.value;
        const e = this.getVariantTitle();
        this.selectOption(e);
      }
      i(this.addToCartBtn.parentNode);
    }
    handleSecondaryOptionSelection(t) {
      const { show: i, hide: s } = e;
      this.model[t.dataset.name] = t.value;
      const n = this.getVariantTitle();
      this.selectOption(n);
    }
    handlePickColorBtnClick() {
      const { show: t, hide: i } = e;
      t(this.optionsView), t(this.colorsView), i(this.pickColorBtn.parentNode);
    }
    handleBackBtnClick() {
      const { show: t, hide: i } = e;
      i(this.secondaryOptionsView),
        t(this.colorsView),
        i(this.addToCartBtn.parentNode);
    }
    handleArrowBtnClick() {
      const { show: t, hide: i } = e;
      i(this.optionsView),
        i(this.colorsView),
        i(this.addToCartBtn.parentNode),
        t(this.pickColorBtn.parentNode);
    }
    async handleAddToCartBtnClick() {
      const { addToCart: t, refreshCart: i } = e,
        s = this.select.value;
      this.disableAtc(), await t(s), this.enableAtc();
    }
    getVariantTitle() {
      return Object.values(this.model).reduce(
        (t, e) => (t ? `${t} / ${e}` : e),
        ""
      );
    }
    selectOption(t) {
      const e = this.variantOptions.find((e) => e.textContent.trim() === t);
      if (!e) {
        this.disableAtc();
        return;
      }

      this.enableAtc();
      this.select.value = e.value;
      this.select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    disableAtc() {
      this.addToCartBtn.disabled = !0;
    }
    enableAtc() {
      this.addToCartBtn.disabled = !1;
    }
  }
  customElements.define("cart-upsell", i), (Shopify.cartUpsellsApp = t);
})();

